'use es6';

import styled from 'styled-components';
const BannersContainer = styled.div.withConfig({
  displayName: "BannersContainer",
  componentId: "sc-103pg8y-0"
})(["> *{margin-bottom:16px;}"]);
export default BannersContainer;